import { Stack } from '@mantine/core';
import {
  resetInitiativeFocusFilters,
  toggleInitiativeFocusSelection,
  toggleInitiativeFocusTrends,
} from '../../../../store/process-analysis-store/process-analysis-store.actions';
import {
  useSelectedInitiativeFocus,
  useSelectedInitiativeFocusTrends,
} from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { ResetFiltersButton } from '../../../../components/filters/reset-filters-button';
import { useInitiativeFocusData } from '../../hooks/initiative-data';
import { getDefaultInitiativeSelection } from '../../process-analysis.helpers';
import { InitiativeList } from '../initiative-list/initiative-list';

export const InitiativeFocus = () => {
  const { data: initiativeFocusData, isFetching } = useInitiativeFocusData();
  const selectedInitiativeFocus = useSelectedInitiativeFocus();
  const selectedInitiativeFocusTrends = useSelectedInitiativeFocusTrends();

  const initiatives = initiativeFocusData?.initiatives || [];

  return (
    <Stack pb={40}>
      <InitiativeList
        initiatives={initiatives}
        selectedInitiatives={selectedInitiativeFocus}
        selectedTrends={selectedInitiativeFocusTrends}
        onToggleSelection={toggleInitiativeFocusSelection}
        onToggleTrend={toggleInitiativeFocusTrends}
        isLoading={isFetching}
      />
      <ResetFiltersButton
        onClick={() => {
          const defaultSelection = getDefaultInitiativeSelection(initiatives);

          resetInitiativeFocusFilters(defaultSelection);
        }}
      />
    </Stack>
  );
};
